// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

// Firebase configuration for clone-2c39d project
const firebaseConfig = {
  apiKey: "AIzaSyBqVZw_Q5O1Lh4n_7v3Z8O-Y2w4nF6vV_M", // Dummy API Key
  authDomain: "nintschew.firebaseapp.com",
  databaseURL: "https://clone-2c39d-default-rtdb.europe-west1.firebasedatabase.app/",
  projectId: "clone-2c39d",
  storageBucket: "clone-2c39d.firebasestorage.app",
  messagingSenderId: "123456789012",
  appId: "1:123456789012:web:abcdef123456789"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const database = getDatabase(app);
export const storage = getStorage(app);

export default app;
